import React from 'react';
import { IconProps } from './iconProps';
import { useTheme } from '@mui/material/styles';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';
import cx from 'classnames';

export default function IconInfo({
  onClick,
  extColor,
  sizeKey = '16x16',
  style,
}: IconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.text.primary;

  const w = defaultSpacingPresets.icons[sizeKey].w;
  const h = defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      className={cx({ 'icon-disabled': !onClick })}
      onClick={onClick}
      width={w}
      height={h}
      viewBox="0 0 16 17"
      fill={fill}
    >
      <path d="M7.33374 5.16701H8.66707V6.50035H7.33374V5.16701Z" />
      <path
        d="M7.33374 5.16701H8.66707V6.50035H7.33374V5.16701Z"
        fillOpacity="0.9"
      />
      <path d="M7.33374 7.83368H8.66707V11.8337H7.33374V7.83368Z" />
      <path
        d="M7.33374 7.83368H8.66707V11.8337H7.33374V7.83368Z"
        fillOpacity="0.9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33374 8.50035C1.33374 4.82035 4.32039 1.83368 8.00041 1.83368C11.6804 1.83368 14.6671 4.82035 14.6671 8.50035C14.6671 12.1803 11.6804 15.167 8.00041 15.167C4.32039 15.167 1.33374 12.1803 1.33374 8.50035ZM2.66707 8.50035C2.66707 11.4403 5.06038 13.8337 8.00041 13.8337C10.9404 13.8337 13.3337 11.4403 13.3337 8.50035C13.3337 5.56034 10.9404 3.16701 8.00041 3.16701C5.06038 3.16701 2.66707 5.56034 2.66707 8.50035Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33374 8.50035C1.33374 4.82035 4.32039 1.83368 8.00041 1.83368C11.6804 1.83368 14.6671 4.82035 14.6671 8.50035C14.6671 12.1803 11.6804 15.167 8.00041 15.167C4.32039 15.167 1.33374 12.1803 1.33374 8.50035ZM2.66707 8.50035C2.66707 11.4403 5.06038 13.8337 8.00041 13.8337C10.9404 13.8337 13.3337 11.4403 13.3337 8.50035C13.3337 5.56034 10.9404 3.16701 8.00041 3.16701C5.06038 3.16701 2.66707 5.56034 2.66707 8.50035Z"
        fillOpacity="0.9"
      />
    </svg>
  );
}
